import React from "react";

function NotFoundPage() {
	return <div className="vh-100 vw-100 flex centerEverything text-center bg-tan fw-800 rubikFont hex-1e ft-100">Page Not Found</div>;
}

export default NotFoundPage;
